import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  FaChevronLeft,
  FaCalendarDay,
  FaClock,
  FaCircleCheck,
  FaArrowRight,
} from "react-icons/fa6";
import { setCheckoutAllData } from "../redux/cart/CartSlice";
import { setSalonHomeCheckoutAllData } from "../redux/cart/HomeSalon";
import { FaExclamationCircle } from "react-icons/fa";
import AddressComponent from "./AddressComponent"; // Use your existing component

const ScheduleAddress = () => {
  const { loginData, currentAddress, address } = useSelector(
    (state) => state.Authentication
  );
  const { CartItems, netPayable, cartTotalMrp } = useSelector(
    (state) => state.Cart
  );
  const { salonHomeCartItems, salonHomeNetPayable, salonHomeCartTotalMrp } =
    useSelector((state) => state.HomeSalonCart);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [cartSts, setCartSts] = useState("");
  const [dateslist, setdateslist] = useState([]);
  const [morningSlot, setmorningSlot] = useState([]);
  const [afternoonslot, setafternoonslot] = useState([]);
  const [eveningslot, seteveningslot] = useState([]);
  const [availabileSlots, setavailabileSlots] = useState(0);
  const [currentslots, setcurrentslots] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [proceedtoCheck, setProceedtoCheck] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [addressValidationError, setAddressValidationError] = useState("");

  useEffect(() => {
    const proceedSts = location.state?.from || "";
    setCartSts(proceedSts);
  }, [location.state]);

  const morSlot = [
    { name: "10-11 AM", time: "10" },
    { name: "11-12 AM", time: "11" },
  ];
  const maftSlot = [
    { name: "10-11 AM", time: "10" },
    { name: "11-12 AM", time: "11" },
    { name: "12-1 PM", time: "12" },
    { name: "1-2 PM", time: "13" },
    { name: "2-3 PM", time: "14" },
    { name: "3-4 PM", time: "15" },
    { name: "4-5 PM", time: "16" },
    { name: "5-6 PM", time: "17" },
  ];
  const eveSlot = [
    { name: "4-5 PM", time: "16" },
    { name: "5-6 PM", time: "17" },
  ];

  useEffect(() => {
    let day = new Date();
    setSelectedDate(day);
    let datearray = [];
    for (let index = 0; index < 7; index++) {
      let todayDate = new Date();
      todayDate.setDate(todayDate.getDate() + Number(index));
      datearray = [...datearray, todayDate];
    }
    setdateslist(datearray);
  }, []);

  useEffect(() => {
    let day = new Date();
    if (moment(selectedDate).format("DD") === moment(day).format("DD")) {
      const currentHour = moment(selectedDate).format("H");

      if (currentHour >= "0" && currentHour <= "9") {
        const filtermorslot = morSlot;
        const filteraftslot = maftSlot;
        const filtereveslot = eveSlot;
        const availslot = [
          ...filtermorslot,
          ...filteraftslot,
          ...filtereveslot,
        ];
        if (availslot.length > 0) {
          const curr = availslot[0].name;
          setcurrentslots(curr);
        }
        setavailabileSlots(availslot.length);
        setmorningSlot([...filtermorslot]);
        setafternoonslot([...filteraftslot]);
        seteveningslot([...filtereveslot]);
      }
      if (currentHour >= "10" && currentHour <= "14") {
        const filtermorslot = morSlot.filter((data) => data.time > currentHour);
        const filteraftslot = maftSlot.filter(
          (data) => data.time > currentHour
        );
        const filtereveslot = eveSlot.filter((data) => data.time > currentHour);
        const availslot = [
          ...filtermorslot,
          ...filteraftslot,
          ...filtereveslot,
        ];
        if (availslot.length > 0) {
          const curr = availslot[0].name;
          setcurrentslots(curr);
        }
        setavailabileSlots(availslot.length);
        setmorningSlot([...filtermorslot]);
        setafternoonslot([...filteraftslot]);
        seteveningslot([...filtereveslot]);
      }
      if (currentHour >= "20") {
        const filtermorslot = morSlot;
        const filteraftslot = maftSlot;
        const filtereveslot = eveSlot;
        const availslot = [
          ...filtermorslot,
          ...filteraftslot,
          ...filtereveslot,
        ];
        if (availslot.length > 0) {
          const curr = availslot[0].name;
          setcurrentslots(curr);
        }
        setavailabileSlots(availslot.length);
        setmorningSlot([...filtermorslot]);
        setafternoonslot([...filteraftslot]);
        seteveningslot([...filtereveslot]);
        const removedate = dateslist.filter(
          (data) => moment(data).format("DD") !== moment(day).format("DD")
        );
        setdateslist(removedate);
        let adddate = new Date();
        adddate.setDate(adddate.getDate() + Number(1));
        setSelectedDate(adddate);
      }
    } else {
      const filtermorslot = morSlot;
      const filteraftslot = maftSlot;
      const filtereveslot = eveSlot;
      const availslot = [...filtermorslot, ...filteraftslot, ...filtereveslot];
      if (availslot.length > 0) {
        const curr = availslot[0].name;
        setcurrentslots(curr);
      }
      setavailabileSlots(availslot.length);
      setmorningSlot([...filtermorslot]);
      setafternoonslot([...filteraftslot]);
      seteveningslot([...filtereveslot]);
    }
  }, [selectedDate]);

  useEffect(() => {
    if (cartSts === "shopcart") {
      setProceedtoCheck(CartItems);
    }
    if (cartSts === "saloncart") {
      setProceedtoCheck(salonHomeCartItems);
    }
  }, [cartSts, CartItems, salonHomeCartItems]);

  const showError = (message) => {
    setErrorMessage(message);
    setTimeout(() => setErrorMessage(""), 5000);
  };

  const validateAddress = () => {
    if (!address || address.length === 0) {
      return "Please add an address before proceeding";
    }

    if (!currentAddress) {
      return "Please select a delivery address";
    }

    if (!currentAddress.HNo || !currentAddress.StreetDet) {
      return "Selected address is incomplete. Please choose a complete address";
    }

    if (!currentAddress.City || !currentAddress.Pincode) {
      return "City and Pincode are required in the selected address";
    }

    return null;
  };

  const proceedClick = async () => {
    setLoading(true);
    setErrorMessage("");
    setAddressValidationError("");

    try {
      // Address validation
      const addressError = validateAddress();
      if (addressError) {
        setAddressValidationError(addressError);
        setLoading(false);
        return;
      }

      if (!loginData || !loginData.Mobile) {
        showError("User information is missing. Please login again.");
        setLoading(false);
        return;
      }

      if (!currentslots) {
        showError("Please select a time slot before proceeding");
        setLoading(false);
        return;
      }

      if (!proceedtoCheck || proceedtoCheck.length === 0) {
        showError("Your cart is empty. Please add items before proceeding.");
        setLoading(false);
        return;
      }

      if (!selectedDate) {
        showError("Please select a date before proceeding");
        setLoading(false);
        return;
      }

      const selectedDateString = moment(selectedDate).format("DD-MM-YYYY");

      const addressString = [
        currentAddress.HNo,
        currentAddress.StreetDet,
        currentAddress.AName,
        currentAddress.LandMark,
        currentAddress.City,
        currentAddress.State,
        "India",
        currentAddress.Pincode,
      ]
        .filter(Boolean)
        .join(", ");

      let concatenatedNames = "";
      for (let index = 0; index < proceedtoCheck.length; index++) {
        if (proceedtoCheck[index]?.ProductName) {
          concatenatedNames += proceedtoCheck[index].ProductName + ",";
        }
      }
      concatenatedNames = concatenatedNames.replace(/,$/, "");

      const formData = {
        Address: addressString,
        AreaName: currentAddress.AName || "",
        Mobile: loginData.Mobile,
        ServicePreferedDate: selectedDateString,
        ServicePreferedTime: currentslots,
        OrderProducts: proceedtoCheck,
        orderDisplayName: concatenatedNames,
      };

      if (cartSts === "shopcart") {
        dispatch(setCheckoutAllData(formData));
        navigate("/payments", {
          state: {
            cartType: "shopcart",
            scheduleData: {
              ServicePreferedDate: selectedDateString,
              ServicePreferedTime: currentslots,
            },
          },
        });
      } else if (cartSts === "saloncart") {
        dispatch(setSalonHomeCheckoutAllData(formData));
        navigate("/payments", {
          state: {
            cartType: "saloncart",
            scheduleData: {
              ServicePreferedDate: selectedDateString,
              ServicePreferedTime: currentslots,
            },
          },
        });
      } else {
        showError("Unknown cart type. Please try again.");
      }
    } catch (error) {
      showError(
        "An error occurred while processing your request. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const DateCard = ({ date, isSelected, onPress }) => (
    <div
      className="text-center mx-1 cursor-pointer"
      onClick={onPress}
      style={{ width: "100px" }}
    >
      <div
        className={`p-3 rounded-3 border-0 ${
          isSelected ? "text-white border-0" : "bg-light border-0"
        }`}
        style={{
          backgroundColor: isSelected ? "#1469A7" : "transparent",
          borderColor: isSelected ? "#1469A7" : "#dee2e6",
        }}
      >
        <div
          className={`fw-semibold mb-2 small ${
            isSelected ? "text-white" : "text-muted"
          }`}
        >
          {moment(date).format("ddd")}
        </div>
        <div className="mb-1">
          <div
            className={`fw-bold fs-6 ${
              isSelected ? "text-white" : "text-dark"
            }`}
          >
            {moment(date).format("DD")}
          </div>
        </div>
        <div
          className={`fw-medium small ${
            isSelected ? "text-white" : "text-secondary"
          }`}
        >
          {moment(date).format("MMM")}
        </div>
      </div>
      {isSelected && (
        <div
          className="mt-2 mx-auto rounded-pill"
          style={{ width: "6px", height: "6px", backgroundColor: "#1469A7" }}
        ></div>
      )}
    </div>
  );

  const TimeSlot = ({ slot, isSelected, onPress }) => (
    <div className="mb-2 col-3 px-1" onClick={onPress}>
      <div
        className={`d-flex align-items-center justify-content-center p-2 rounded-3 border-0 ${
          isSelected ? "border-0 text-white" : "bg-light border-0 text-dark"
        }`}
        style={{
          backgroundColor: isSelected ? "#1469A7" : "transparent",
          borderColor: isSelected ? "#1469A7" : "#dee2e6",
        }}
      >
        <span
          className={`fw-semibold small ${
            isSelected ? "text-white" : "text-dark"
          }`}
        >
          {slot.name}
        </span>
        {isSelected && <FaCircleCheck className="text-white ms-1" size={14} />}
      </div>
    </div>
  );

  const SelectedSummary = () => {
    const cartData =
      cartSts === "shopcart"
        ? {
            netPayable,
            totalMrp: cartTotalMrp,
            savings: cartTotalMrp - netPayable,
            items: CartItems,
          }
        : {
            netPayable: salonHomeNetPayable,
            totalMrp: salonHomeCartTotalMrp,
            savings: salonHomeCartTotalMrp - salonHomeNetPayable,
            items: salonHomeCartItems,
          };

    return (
      <div className="bg-white rounded-4 p-4 border-0 h-100">
        <h6 className="fw-bold mb-4 border-bottom pb-3 text-start">
          Schedule Summary
        </h6>

        {/* Selected Date & Time */}
        <div className="mb-4 text-start">
          <h6 className="fw-semibold text-muted mb-3">Selected Schedule</h6>
          <div className="bg-light rounded-3 p-3">
            <div className="d-flex align-items-center mb-2">
              <FaCalendarDay
                className="me-2"
                size={16}
                style={{ color: "#1469A7" }}
              />
              <span className="fw-semibold">Date:</span>
              <span className="ms-2 fw-bold text-dark">
                {selectedDate
                  ? moment(selectedDate).format("ddd, MMM DD, YYYY")
                  : "Not selected"}
              </span>
            </div>
            <div className="d-flex align-items-center">
              <FaClock
                className="me-2"
                size={16}
                style={{ color: "#1469A7" }}
              />
              <span className="fw-semibold">Time:</span>
              <span className="ms-2 fw-bold text-dark">
                {currentslots || "Not selected"}
              </span>
            </div>
          </div>
        </div>

        {/* Savings Message */}
        {cartData.savings > 0 && (
          <div className="bg-success bg-opacity-10 rounded-3 p-3 mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <span className="fw-semibold text-success">You Save</span>
              <span className="fw-bold text-success">₹{cartData.savings}</span>
            </div>
          </div>
        )}

        {/* Proceed Button */}
        <button
          className={`btn w-100 py-3 fw-bold rounded-3 border-0 text-white ${
            !currentslots || !currentAddress || loading ? "btn-secondary" : ""
          }`}
          style={{
            backgroundColor:
              !currentslots || !currentAddress || loading
                ? "#6c757d"
                : "#b93c5b",
          }}
          onClick={proceedClick}
          disabled={!currentslots || !currentAddress || loading}
        >
          {loading ? (
            <>
              <div
                className="spinner-border spinner-border-sm me-2"
                role="status"
              ></div>
              PROCESSING...
            </>
          ) : (
            <>
              CheckOut
              <FaArrowRight className="ms-2" />
            </>
          )}
        </button>
      </div>
    );
  };

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div
        className="py-4 position-sticky top-0 z-3"
        style={{ backgroundColor: "#1469A7" }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-auto">
              <button
                onClick={() => navigate(-1)}
                className="btn btn-link text-white p-0"
              >
                <FaChevronLeft size={24} />
              </button>
            </div>
            <div className="col text-center">
              <h5 className="mb-0 fw-bold text-white">Schedule & Address</h5>
            </div>
            <div className="col-auto" style={{ width: "40px" }}></div>
          </div>
        </div>
      </div>

      {/* Error Banner */}
      {errorMessage && (
        <div style={{ backgroundColor: "#b93c5b" }}>
          <div className="container">
            <div className="d-flex align-items-center justify-content-center py-2">
              <FaExclamationCircle className="me-2" size={16} />
              <span className="fw-semibold text-white">{errorMessage}</span>
            </div>
          </div>
        </div>
      )}

      {/* Main Content - Split Layout */}
      <div className="container py-4">
        <div className="row">
          {/* Left Side - Scheduling & Address */}
          <div className="col-lg-8 col-md-7 mb-4">
            {/* Address Selection - Using your existing AddressComponent */}
            <AddressComponent />

            {/* Show address validation error if any */}
            {addressValidationError && (
              <div className="alert alert-warning py-2 mb-3 small" role="alert">
                <FaExclamationCircle className="me-2" />
                {addressValidationError}
              </div>
            )}

            {/* Date Selection */}
            <div className="bg-white rounded-4 p-4 mb-4 border-0">
              <h6 className="fw-bold mb-3 text-start">Select Date</h6>
              <div className="d-flex overflow-auto pb-2">
                {dateslist.map((date, index) => (
                  <DateCard
                    key={index}
                    date={date}
                    isSelected={
                      moment(selectedDate).format("DD") ===
                      moment(date).format("DD")
                    }
                    onPress={() => {
                      setSelectedDate(date);
                      setcurrentslots("");
                    }}
                  />
                ))}
              </div>
            </div>

            {/* Time Slots */}
            <div className="bg-white rounded-4 p-4 border-0">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold mb-0">Available Time Slots</h6>
                <span className="text-muted fw-medium">
                  {availabileSlots} slots available
                </span>
              </div>
              <div className="row g-1">
                {afternoonslot.map((slot, index) => (
                  <TimeSlot
                    key={index}
                    slot={slot}
                    isSelected={currentslots === slot.name}
                    onPress={() => setcurrentslots(slot.name)}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Right Side - Selected Summary */}
          <div className="col-lg-4 col-md-5">
            <SelectedSummary />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleAddress;